// accessState is the 4-state booking window from the api (deriveState).
export const ACCESS_STATE_DISPLAY = {
	pre_window: { label: 'Upcoming', flavour: 'gray' },
	active: { label: 'Active', flavour: 'success' },
	expired: { label: 'Ended', flavour: 'gray' },
	cancelled: { label: 'Cancelled', flavour: 'gray' },
};

// position is the physical bollard BayStatus. Nick's console vocab:
// OPEN (lowered, passable) → Accessible; CLOSED (raised, blocking) → Protected.
export const BOLLARD_POSITION_DISPLAY = {
	OPEN: { label: 'Accessible', flavour: 'primary' },
	CLOSED: { label: 'Protected', flavour: 'success' },
	JAMMED: { label: 'Jammed', flavour: 'danger' },
	UNKNOWN: { label: 'Unknown', flavour: 'gray' },
};

// Each outcome carries a tone so success and failure never render identically.
export const OUTCOME_MESSAGE = {
	SUCCESS: { text: 'Done.', tone: 'success' },
	BARRIER_BUSY: { text: 'The bollard is busy — try again in a moment.', tone: 'danger' },
	JAMMED: { text: 'The bollard did not respond (jammed). Check the device.', tone: 'danger' },
	CAR_PRESENT: { text: 'A vehicle is on the bay — the bollard will not raise.', tone: 'danger' },
	REASON_REQUIRED: { text: 'A reason is required to raise the bollard.', tone: 'danger' },
	BAY_NOT_FOUND: { text: 'No Parklio bay is linked to this booking.', tone: 'danger' },
	BAY_UNCONFIGURED: { text: 'This bay has no Parklio device configured.', tone: 'danger' },
};

// An outcome the console does not recognise must not masquerade as success.
export const UNKNOWN_OUTCOME_MESSAGE = {
	text: 'Command sent — refresh to confirm the bollard state.',
	tone: 'info',
};
